module.exports = __webpack_public_path__ + "static/media/gatorProtect.97e9da5c.svg";